var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.691 6.28a.57.57 0 0 1-.198.783l-1.078.64 1.12.804a.57.57 0 1 1-.668.928l-1.828-1.314a.57.57 0 0 1 .042-.954l1.828-1.086a.57.57 0 0 1 .783.2zM12.067 22.485a.57.57 0 0 1 .792-.162c.896.592 3.4 1.833 6.056 1.963 2.634.13 5.273-1.037 6.245-1.63a.57.57 0 1 1 .595.974c-1.085.664-3.954 1.942-6.897 1.798-2.922-.144-5.622-1.486-6.63-2.151a.57.57 0 0 1-.162-.792zm18.7-9.127A1.257 1.257 0 1 0 28.72 11.9l-2.401 3.37c-.295.413-.312.96-.047 1.39l2.4 3.886a1.257 1.257 0 0 0 2.14-1.32l-1.962-3.177 1.917-2.692zM19.458 14.71v5.004a1.257 1.257 0 1 1-2.514 0v-5.063a3.33 3.33 0 0 1 .865-2.095c.653-.72 1.644-1.184 2.963-1.184 2.727.001 3.95 1.914 4.2 3.043l.03.135v5.166a1.257 1.257 0 1 1-2.514 0v-4.853c-.12-.313-.558-.974-1.715-.974-.69 0-.976.222-1.1.359a.84.84 0 0 0-.213.465zm-3.886-2.31a1.257 1.257 0 1 0-2.513 0v7.086a1.257 1.257 0 0 0 2.514 0V12.4zm-4.777-1.047c.674.17 1.082.853.912 1.526l-1.657 6.57a1.257 1.257 0 0 1-2.386.161l-1.304-3.243L5.02 19.62a1.257 1.257 0 0 1-2.384-.18l-1.6-6.571a1.257 1.257 0 1 1 2.443-.596l.685 2.816 1.044-2.54a1.257 1.257 0 0 1 2.328.01l1.017 2.53.712-2.826a1.257 1.257 0 0 1 1.526-.911zm3.236-1.924a1.43 1.43 0 1 0-.001-2.858 1.43 1.43 0 0 0-.001 2.857z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWin);
export default __webpack_public_path__ + "static/media/WIN.0f406c3038324d18a0c4db50c2821865.svg";
export { ForwardRef as ReactComponent };